<template>
  <div>
    <CModal
      add-content-classes="mca-login-modal"
      :show.sync="isAuthe"
      :centered="true"
      size="lg"
    >
      <template #header-wrapper>
        <div></div>
      </template>

      <template #body-wrapper>
        <div class="mca-login-modal__shell">
          <div class="mca-login-modal__brand">
            <img src="@/assets/mfu_logo.png" alt="MFU Logo" class="mca-login-modal__logo" />
            <h2>MFU Collaboration Agreements</h2>
            <p>Mae Fah Luang University</p>
          </div>

          <div class="mca-login-modal__card">
            <div class="mca-login-modal__copy">
              <h3>Sign in with MFU Google</h3>
              <p>Use your MFU account to continue into the agreement workspace.</p>
            </div>

            <div v-if="error" class="mca-login-modal__error">
              {{ error }}
            </div>

            <button class="mca-login-modal__sso" type="button" :disabled="loading" @click="onAuthenGoogle">
              <img src="@/assets/icons/logo-google.png" alt="Google" class="mca-login-modal__sso-icon" />
              <span v-if="loading">Signing in...</span>
              <span v-else>Continue with Google</span>
            </button>

            <p class="mca-login-modal__note">
              Authentication and access checks are enabled. Please sign in with an approved MFU account.
            </p>
          </div>
        </div>
      </template>

      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>
  </div>
</template>

<script>

    import {mapGetters} from 'vuex'

    export default {
        name: 'SignIn',
        data() {
          return {
            loading: false,
            error: null
          }
        },
        methods: {
          async onAuthenGoogle() {
            this.error = null
            this.loading = true
            try {
              const googleUser = await this.$gAuth.signIn();
              const id_token = googleUser.getAuthResponse().id_token;
              const body = {
                token: id_token,
                authType: "689c06d5255db4e56aea8902"
              };
              await this.$store.dispatch("auth/signIn", body)

            } catch (err) {
              this.error = (err && err.message) ? err.message : 'Google Sign-In failed. Please try again.'
              this.$store.commit('dialog/showError', {
                title: "Authentication Error",
                message: "Google Sign-In failed. Please try again.",
                code: "AUTH_GOOGLE_FAILED",
                number: "1",
                status: true
              })
            } finally {
              this.loading = false
            }
          },
        },

        computed: {
            ...mapGetters({
              showSignIn: 'auth/isSignIn'
            }),
            isAuthe: {
              get() {
                return this.showSignIn
              },
              set(value) {
                this.$store.commit("auth/isSignIn", !!value)
              }
            }
          },
    }
</script>

<style>
.mca-login-modal {
  background: transparent;
  border: 0;
  border-radius: 22px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.28);
  overflow: hidden;
}

.mca-login-modal .modal-body {
  padding: 0;
}

.mca-login-modal__shell {
  background: #9E212F;
  padding: 34px 28px;
}

.mca-login-modal__brand {
  color: #ffffff;
  margin: 0 auto 26px;
  max-width: 480px;
  text-align: center;
}

.mca-login-modal__logo {
  height: 118px;
  margin-bottom: 18px;
  width: auto;
}

.mca-login-modal__brand h2 {
  color: #ffffff;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.25;
  margin: 0 0 8px;
}

.mca-login-modal__brand p {
  color: rgba(255, 255, 255, 0.88);
  font-size: 15px;
  margin: 0;
}

.mca-login-modal__card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.14);
  margin: 0 auto;
  max-width: 500px;
  padding: 34px;
}

.mca-login-modal__copy {
  margin-bottom: 22px;
  text-align: center;
}

.mca-login-modal__copy h3 {
  color: #1E293B;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0;
  margin: 0 0 8px;
}

.mca-login-modal__copy p,
.mca-login-modal__note {
  color: #64748B;
  font-size: 15px;
  line-height: 1.6;
  margin: 0;
}

.mca-login-modal__error {
  background: #f8d7da;
  border-radius: 6px;
  color: #dc3545;
  font-size: 14px;
  margin-bottom: 18px;
  padding: 9px 12px;
  text-align: center;
}

.mca-login-modal__sso {
  align-items: center;
  background: #ffffff;
  border: 1.5px solid #E2E8F0;
  border-radius: 12px;
  color: #1E293B;
  cursor: pointer;
  display: flex;
  font-size: 15px;
  font-weight: 600;
  gap: 12px;
  justify-content: center;
  margin-bottom: 18px;
  padding: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  width: 100%;
}

.mca-login-modal__sso:hover {
  border-color: #9E212F;
  box-shadow: 0 0 0 3px rgba(158, 33, 47, 0.08);
}

.mca-login-modal__sso:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.mca-login-modal__sso-icon {
  height: 20px;
  width: 20px;
}

.mca-login-modal__note {
  font-size: 13px;
  text-align: center;
}

@media (max-width: 575.98px) {
  .mca-login-modal__shell {
    padding: 28px 18px;
  }

  .mca-login-modal__card {
    padding: 28px 22px;
  }

  .mca-login-modal__brand h2,
  .mca-login-modal__copy h3 {
    font-size: 22px;
  }
}
</style>
